export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_15-a31ced71a7adb48c0d8e324013e5cae0.webp";